
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "PartnerProfile",
  data() {
    return {
      loading: false,
      profileData: {},
    };
  },
  computed: {
    ...mapGetters("INFORMATICS_STORE", [
      "getUserProfileParams",
      "getUserProfileData",
    ]),
  },
  watch: {
    profileData: {
      handler() {
        if (this.getUserProfileData?.id === undefined) {
          this.$router.push("/informatics/user-management");
        }
      },
    },
  },
  mounted() {
    this.profileData = this.getUserProfileData;
  },
});
